import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Clock, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { track } from "../lib/analytics";
import Seo from "../components/Seo";
import { NewsletterSignup } from "../components/NewsletterSignup";

export default function KutuphaneDetail() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setC(null); setNotFound(false);
    api.get(`/content/${slug}`)
      .then(({ data }) => { setC(data); track("content_view", { slug: data.slug, title: data.title }); })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="pt-40 pb-32 text-center">
      <h1 className="font-serif text-4xl text-brand-green">İçerik bulunamadı</h1>
      <Link to="/kutuphane" className="text-brand-gold mt-4 inline-block link-underline">Kütüphaneye dön</Link>
    </div>
  );
  if (!c) return <div className="pt-40 pb-40 text-center text-brand-text/50">Yükleniyor…</div>;

  const jsonLd = {
    "@context": "https://schema.org", "@type": "Article", headline: c.title,
    description: c.seo_description || c.excerpt, image: c.cover_image, author: { "@type": "Organization", name: c.author },
    datePublished: c.published_at, publisher: { "@type": "Organization", name: "Bilgece" },
  };

  return (
    <>
      <Seo title={c.seo_title || c.title} description={c.seo_description || c.excerpt} image={c.cover_image} type="article" jsonLd={jsonLd} />

      <article className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/kutuphane" className="inline-flex items-center gap-2 text-brand-text/60 hover:text-brand-green text-sm mb-8"><ArrowLeft size={16} /> Kütüphane</Link>
          <span className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold">{c.category} · {c.content_type}</span>
          <h1 className="font-serif text-4xl md:text-5xl font-light text-brand-green mt-4 leading-tight">{c.title}</h1>
          <div className="flex items-center gap-3 mt-5 text-sm text-brand-text/55">
            <span>{c.author}</span><span>·</span>
            <span className="inline-flex items-center gap-1.5"><Clock size={14} /> {c.reading_time} dk okuma</span>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 mt-10">
          <div className="rounded-sm overflow-hidden">
            <img src={c.cover_image} alt={c.title} className="w-full h-72 md:h-[420px] object-cover" />
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-6 mt-12">
          <p className="font-serif text-2xl text-brand-green/90 italic leading-relaxed mb-8">{c.excerpt}</p>
          <div className="prose-bilgece text-brand-text/85 text-lg leading-[1.9] space-y-6">
            {c.body.split("\n").filter(Boolean).map((para, i) => <p key={i}>{para}</p>)}
          </div>

          {c.tags?.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-12">
              {c.tags.map((t) => <span key={t} className="bg-brand-cream border border-brand-gold-light/40 text-brand-text/60 text-xs px-3 py-1.5 rounded-full">#{t}</span>)}
            </div>
          )}
        </div>

        <div className="max-w-3xl mx-auto px-6 mt-16">
          <div className="bg-brand-green text-brand-offwhite rounded-sm p-8 md:p-10">
            <h3 className="font-serif text-2xl mb-2">Bilgece Mektup</h3>
            <p className="text-brand-offwhite/70 text-sm mb-5">Haftada bir. Gürültü değil, düşünmeye değer tek bir fikir.</p>
            <NewsletterSignup variant="footer" />
          </div>
        </div>
      </article>
    </>
  );
}
